import { XMarkIcon } from "@heroicons/react/20/solid";
import { addYears, format, isAfter, isValid } from "date-fns";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { Actions as EMPLOYEEACTIONS } from "../../../store/actions/employeeActions";
import { DateInputFormat, handleRawDate } from "../../common/DateComponents";


const UpdateTerminationDateModal = ({
	terminationDate,
	setTerminationDate,
	closeModal,
	modalStatus,
	engagementDate,
	saving,
}) => {
	const [terminationDateToSave, setTerminationDateToSave] = useState(terminationDate);

	if (!modalStatus) {
		return null;
	}

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto", overflowX: "hidden" }}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="block block-themed block-transparent remove-margin-b">
						<div className="block-header bg-primary-dark">
							<ul className="block-options">
								<li>
									<button
										data-dismiss="modal"
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Confirm Termination Date</h3>
						</div>
						<div className="modal-body">
							<div className="clearfix" />
							{terminationDate
								? `Update or Undo termination. If you are re-employing the same employee do not cancel termination but re-engage. Payslips impacted are not automatically re-calculated.`
								: `Choose your employee's termination date. If payslips were issued that include pay after the date of termination they are not automatically updated/calculated. Additional final pay may be due.`}
							<div className="clearfix" />
						</div>
						<div className="col-xs-12">
							<form
								onSubmit={(e) => {
									e.preventDefault();
									e.stopPropagation();
									if (!terminationDateToSave) return;
									setTerminationDate(format(terminationDateToSave, "yyyy-MM-dd"));
								}}
							>
								<div className="col-xs-6 form-container">
									<label htmlFor="terminationDate">Termination Date</label>
									<DatePicker
										name="terminationDate"
										selected={terminationDateToSave}
										defaultValue={(terminationDate && new Date(terminationDate)) || null}
                    					wrapperClassName="full-width"
										dateFormat="dd MMM yyyy"
										minDate={engagementDate}
										maxDate={addYears(new Date(), 100)}
										customInput={<DateInputFormat />}
										onChangeRaw={(e) =>
											handleRawDate(e.target.value, (date) => {
												if (isAfter(date, addYears(new Date(), 100)) || date < engagementDate) return;
												if (isValid(date)) setTerminationDateToSave(date);
											})
										}
										onChange={(date) => setTerminationDateToSave(date)}
										strictParsing
										autoComplete="off"
									/>
								</div>
								<div className="clearfix" />
								<div className="col-xs-12 form-container">
									{terminationDate && (
										<div
											className="btn btn-danger pull-left"
											onClick={() => setTerminationDate(null)}
										>
											Undo Termination
										</div>
									)}
									{!saving && (
										<button
											className="btn btn-success pull-right"
											disabled={!terminationDateToSave}
											type="submit"
										>
											Save Termination Date
										</button>
									)}
									{saving && (
										<div className="btn btn-success pull-right">Saving Termination Date...</div>
									)}
								</div>
							</form>
						</div>
						<div className="clearfix" />
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { salaries, terminationDateModal, terminationDateSaving } = state.employee;

  const lastSalary = state.employee.salaries && state.employee.salaries[state.employee.salaries.length - 1];
  const terminationDate = lastSalary?.end ? lastSalary?.end : null

	return {
		engagementDate:
			state.employee?.salaries && state.employee?.salaries[0] && new Date(state.employee.salaries[0].start),
		terminationDate: terminationDate && new Date(terminationDate),
		modalStatus: terminationDateModal,
		saving: terminationDateSaving,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(EMPLOYEEACTIONS.terminationDateModal(false)),
	setTerminationDate: (terminationDate) => dispatch(EMPLOYEEACTIONS.setTerminationDate(terminationDate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTerminationDateModal);
